module.exports = __webpack_public_path__ + "static/media/up-chevron.e8d338ab.svg";